import { motion } from 'framer-motion'
import { HiArrowRight, HiOutlineClipboardList } from 'react-icons/hi'
import { Button } from '@/components/Button'
import { useLanguage } from '@/i18n/LanguageContext'

export function Hero() {
  const { t } = useLanguage()

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-primary-950"
    >
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%239C92AC\' fill-opacity=\'0.04\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-50" aria-hidden="true" />
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-primary-500/20 rounded-full blur-3xl" aria-hidden="true" />
      <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-primary-600/10 rounded-full blur-3xl" aria-hidden="true" />

      <div className="container-custom relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <motion.p
            className="text-primary-400 font-medium text-sm uppercase tracking-widest mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {t.hero.badge}
          </motion.p>
          <motion.h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            {t.hero.titlePrefix}{' '}
            <span className="text-primary-400">{t.hero.titleHighlight}</span> {t.hero.titleSuffix}
          </motion.h1>
          <motion.p
            className="mt-6 text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {t.hero.description}
          </motion.p>
          <motion.div
            className="mt-10 flex flex-wrap gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <Button
              onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
              className="gap-2"
            >
              {t.common.requestContact}
              <HiArrowRight className="h-5 w-5" />
            </Button>
            <Button
              variant="outline"
              className="border-slate-500 text-slate-200 hover:bg-white/10 gap-2"
              onClick={() => document.getElementById('servicos')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {t.common.exploreServices}
              <HiOutlineClipboardList className="h-5 w-5" />
            </Button>
          </motion.div>
        </div>

        <motion.div
          className="relative hidden lg:block"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
        >
          <div className="relative rounded-2xl bg-slate-800/50 border border-slate-700/50 p-8 shadow-2xl backdrop-blur">
            <div className="flex gap-2 mb-6">
              <span className="h-3 w-3 rounded-full bg-red-500/80" />
              <span className="h-3 w-3 rounded-full bg-yellow-500/80" />
              <span className="h-3 w-3 rounded-full bg-green-500/80" />
            </div>
            <div className="space-y-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className="h-3 rounded bg-slate-700/80"
                  style={{ width: `${60 + i * 8}%` }}
                />
              ))}
            </div>
            <div className="mt-6 grid grid-cols-3 gap-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-20 rounded-lg bg-slate-700/60" />
              ))}
            </div>
            <div className="absolute -bottom-4 -right-4 h-24 w-24 rounded-xl bg-primary-500/30 blur-2xl" aria-hidden="true" />
          </div>
        </motion.div>
      </div>
    </section>
  )
}
